// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgRentalDeviceIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M8.01 20h2v1c0 .55-.45 1-1 1s-1-.45-1-1zm6 1c0 .55.45 1 1 1s1-.45 1-1v-1h-2zM18 3v15c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h10c.55 0 1 .45 1 1m-6 12H8v2h4zm4 1c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1" />
  </g>
);
export default SvgRentalDeviceIcon;
SvgRentalDeviceIcon.displayName = 'SvgRentalDeviceIcon';
